import io from 'socket.io-client'
import { v4 } from 'uuid'
import config from '../../../config'
import { EventEmitter } from '../../../tools/events'

const uuidV4 = () => {
  return v4()
}
const emitter = new EventEmitter()
let sessionUUID = uuidV4();

export type IConfirmDto = {
  phone: string;
  client_uuid: string;
  wait_phone: string;
  type?: string;
}

const SESSION_KEY = 'client_uuid'
const genExpireAt = () => {
 const now = new Date()
 const expireAt = new Date();
  expireAt.setDate(now.getDate() + 1)
  expireAt.setHours(4)
  expireAt.setMinutes(0)
  expireAt.setSeconds(0)
  expireAt.setMilliseconds(0)
  return expireAt
}
const store = {
  getValue: () => {
    const value = localStorage.getItem(SESSION_KEY)
    try {
      return value ? JSON.parse(value) : null
    } catch (e) {
      return null
    }
  },
  setValue: (value: any) => {
    localStorage.setItem(SESSION_KEY, JSON.stringify(value))
  },
  load: () => {
    let value = store.getValue()
    const isExpired = !value || Date.now() > new Date(value.expireAt).getTime()
    if (isExpired) {
      value = { uuid: sessionUUID, expireAt: genExpireAt() }
      store.setValue(value)
    } else {
      sessionUUID = value.uuid
    }
  }
}

store.load()
let socket: any
const tag = '[Session]'

const connect = () => {
  if (socket && socket.connected) {
    socket.disconnect()
  }
  socket = io(`${config.chat.baseURL}/session`, {
    query: {
      app: 'medic',
      uuid: sessionUUID,
    },
    secure: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
  })
  socket.on('connect', () => {
    console.log(tag, 'connected session', sessionUUID)
  })
  socket.on('disconnect', (reason: any) => {
    console.log(tag, 'disconnected session', sessionUUID, reason)
  })
  const events = [
    'send_sms_code',
    'check_sms_code',
    'confirmed',
  ]
  events.forEach(event => {
    socket.on(event, (...args: any) => {
      emitter.emit(event, ...args)
      console.log(tag, 'Socket.IO-Client Event:', event, ...args)
    })
  })
  socket.on('error', (err: any) => {
    console.log(tag, 'error', err)
  })
  socket.on('connect_error', (err: any) => {
    console.log(tag, 'connect_error', err.message)
  })
}

connect()

const waitcallParams = Object.freeze({
  get client_uuid() {
    return sessionUUID
  },
  type: 'waitcall',
})

export { sessionUUID, waitcallParams, emitter }
